import { ContentSourceObject } from '../model';

export const encodeContentSource = (contentSource: ContentSourceObject): string => contentSource
	.categories
	.map((cat) => `categories=${cat}`)
	.join('&');

export const decodeContentSource = (contentSource: string | undefined): ContentSourceObject => {
	const categories = new URLSearchParams(contentSource).getAll('categories');
	return {
		categories,
	};
};
